import { medicalHardshipLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses(data, userInfo, stepWhatHappenedData, nameClaimType) {
  const criticalIllness = mapToCriticalIllness(data, userInfo, stepWhatHappenedData, nameClaimType);
  const disability = mapToDisability(data, userInfo, stepWhatHappenedData, nameClaimType);
  const dismemberment = mapToDismemberment(data, userInfo, stepWhatHappenedData, nameClaimType);
  const leaveOfAbsence = mapToLeaveOfAbsence(data, userInfo, stepWhatHappenedData, nameClaimType);
  const death = mapToDeath(data, userInfo, stepWhatHappenedData, nameClaimType);
  return [...criticalIllness, ...disability, ...dismemberment, ...leaveOfAbsence, ...death];
}

function mapToCriticalIllness(data, userInfo, stepWhatHappenedData, nameClaimType) {
  const expenses = [];
  if (nameClaimType === 'Critical Illness') {
    const claimCode = expenseLookup.criticalIllness.claimCode;
    const listFieldMapDes = [data.whatEventHappenedForCritical, data.typeOfCareFacilityForCritical];
    const description = listFieldMapDes.filter((x) => x).join(' | ');
    const expense = mapExpenseItem(data.whatDateThisOccur, userInfo, stepWhatHappenedData, claimCode, nameClaimType, description);
    expenses.push(expense);
  }
  return expenses;
}

function mapToDisability(data, userInfo, stepWhatHappenedData, nameClaimType) {
  const expenses = [];
  if (nameClaimType === 'Disability') {
    const claimCode = expenseLookup.disability.claimCode;
    const listFieldMapDes = [data.whatEventHappenedForDisability, data.typeOfCareFacilityForDisability];
    const description = listFieldMapDes.filter((x) => x).join(' | ');
    const expense = mapExpenseItem(data.dateOfAccidentForDisability, userInfo, stepWhatHappenedData, claimCode, nameClaimType, description);
    expenses.push(expense);
  }
  return expenses;
}

function mapToDismemberment(data, userInfo, stepWhatHappenedData, nameClaimType) {
  const expenses = [];
  if (nameClaimType === 'Dismemberment') {
    const claimCode = expenseLookup.dismemberment.claimCode;
    const listFieldMapDes = [data.natureOfDismemberment, data.typeOfCareFacilityForDismemberment];
    const description = listFieldMapDes.filter((x) => x).join(' | ');
    const expense = mapExpenseItem(data.whatDateDidThisOccurForDismemberment, userInfo, stepWhatHappenedData, claimCode, nameClaimType, description);
    expenses.push(expense);
  }
  return expenses;
}

function mapToLeaveOfAbsence(data, userInfo, stepWhatHappenedData, nameClaimType) {
  const expenses = [];
  if (nameClaimType === 'Leave Of Absence') {
    const claimCode = expenseLookup.leaveOfAbsence.claimCode;
    const listFieldMapDes = [data.didYourEmployerAllowYouAnApprovedLeaveOfAbsence, data.employerName, data.employerEmail];
    const description = listFieldMapDes.filter((x) => x).join(' | ');
    const expense = mapExpenseItem(data.onWhatDateDidYourLeaveStart, userInfo, stepWhatHappenedData, claimCode, nameClaimType, description);
    expenses.push(expense);
  }
  return expenses;
}

function mapToDeath(data, userInfo, stepWhatHappenedData, nameClaimType) {
  const expenses = [];
  if (nameClaimType === 'Death') {
    const claimCode = expenseLookup.death.claimCode;
    const description = nameClaimType;
    const expense = mapExpenseItem(data.dateOfDeath, userInfo, stepWhatHappenedData, claimCode, nameClaimType, description);
    expenses.push(expense);
  }
  return expenses;
}

function mapExpenseItem(date, userInfo, stepWhatHappenedData, claimCode, nameClaimType, description) {
  return {
    shortDescription: description,
    dateOfExpense: date,
    clientCost: stepWhatHappenedData.whatIsTheOutstandingDuesAmount,
    currency: stepWhatHappenedData.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimFor: userInfo.name,
    nameClaimType,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepMedicalHardshipDataMapper.js